import { render, staticRenderFns } from "./TagNameSelect.vue?vue&type=template&id=f54d9700&"
import script from "./TagNameSelect.vue?vue&type=script&lang=js&"
export * from "./TagNameSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports